import { Directive } from '@angular/core';

@Directive({
  selector: '[nttSuffix]',
})
export class NttSuffix {}
